const RECOVERY_SESSION_KEY = 'pt-platform:stale-asset-recovery:v1';

const STALE_ASSET_PATTERNS = [
    /Unable to preload CSS/i,
    /Unable to preload JS/i,
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    /ChunkLoadError/i,
    /Loading chunk \d+ failed/i,
    /error loading dynamically imported module/i,
];

export function isStaleAssetError(value: unknown): boolean {
    const message = value instanceof Error
        ? value.message
        : typeof value === 'string'
            ? value
            : typeof (value as any)?.message === 'string'
                ? (value as any).message
                : '';

    return STALE_ASSET_PATTERNS.some(pattern => pattern.test(message));
}

async function clearBrowserAppCaches(): Promise<void> {
    await Promise.allSettled([
        'caches' in window
            ? caches.keys().then(keys => Promise.all(keys.map(key => caches.delete(key))))
            : Promise.resolve(),
        'serviceWorker' in navigator
            ? navigator.serviceWorker.getRegistrations().then(registrations => Promise.all(
                registrations.map(registration => registration.unregister()),
            ))
            : Promise.resolve(),
    ]);
}

export async function recoverFromStaleAssets(): Promise<boolean> {
    if (sessionStorage.getItem(RECOVERY_SESSION_KEY) === 'reloaded') {
        return false;
    }

    sessionStorage.setItem(RECOVERY_SESSION_KEY, 'reloaded');
    await clearBrowserAppCaches();
    window.location.reload();
    return true;
}

export function installStaleAssetRecovery(): void {
    window.addEventListener('vite:preloadError', (event: Event) => {
        event.preventDefault();
        void recoverFromStaleAssets();
    });

    window.addEventListener('error', (event: ErrorEvent) => {
        if (isStaleAssetError(event.error) || isStaleAssetError(event.message)) {
            event.preventDefault();
            void recoverFromStaleAssets();
        }
    });

    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        if (isStaleAssetError(event.reason)) {
            event.preventDefault();
            void recoverFromStaleAssets();
        }
    });
}
